import axios from "axios";
import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PaginationComponent,
  ProductPropertyTable,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Card } from "reactstrap";

export const ProductPropertyManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [, setEditedId] = useState();
  const [formData, setFormData] = useState({
    productName: "",
    minDaysElapsed: 0,
    maxDaysElapsed: 0,
    penalRate: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [productProperty, setProductProperty] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [, setIsLoadBtn] = useState(false);
  const [, setDetails] = useState({});
  // const [, setSelectedOption] = useState(null);

  // const onInputChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // const resetForm = () => {
  //   setFormData({
  //     productName: "",
  //     minDaysElapsed: 0,
  //     maxDaysElapsed: 0,
  //     penalRate: 0,
  //   });
  // };

  const getAllProductProperty = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproperty`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProductProperty(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  // const addProductProperty = async (obj) => {
  //   try {
  //     setIsLoadBtn(true);
  //     setIsLoading(true);
  //     const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/trproperty`, obj, {
  //       headers: authHeader(),
  //     });
  //     const { data } = await response.data;
  //     if (data) {
  //       // setProductProperty(data);
  //       getAllProductProperty();
  //       setIsLoadBtn(false);
  //       setIsLoading(false);
  //       setModal({ add: false });
  //       resetForm();
  //     }
  //     return { data };
  //   } catch (error) {
  //     const message = error.response;
  //     setIsLoadBtn(false);
  //     setIsLoading(false);
  //     setModal({ add: false });
  //     resetForm();
  //     return { message };
  //   }
  // };

  // const editproductProperty = async (obj) => {
  //   try {
  //     setIsLoadBtn(true);
  //     const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/trproperty`, obj, {
  //       headers: authHeader(),
  //     });
  //     const formData = await response.data;
  //     if (formData) {
  //       getAllProductProperty();
  //       setIsLoadBtn(false);
  //       setIsLoading(false);
  //       setModal({ edit: false });
  //       resetForm();
  //     }
  //     return { formData };
  //   } catch (error) {
  //     const message = error.response;
  //     setIsLoadBtn(false);
  //     setIsLoading(false);
  //     setModal({ edit: false });
  //     resetForm();
  //     return { message };
  //   }
  // };

  // const onFormCancel = () => {
  //   setModal({ edit: false, add: false });
  //   resetForm();
  // };

  // const onFormSubmit = () => {
  //   addProductProperty(formData);
  //   resetForm();
  //   // setModal({ add: false });
  // };

  // const onEditSubmit = () => {
  //   editproductProperty(formData);
  //   resetForm();
  //   // setModal({ edit: false });
  // };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      productName: items.productName,
      minDaysElapsed: items.minDaysElapsed,
      maxDaysElapsed: items.maxDaysElapsed,
      penalRate: items.penalRate,
    });
    setDetails(items);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = productProperty?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllProductProperty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Product Property Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Product Property</BlockTitle>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ProductPropertyTable
                productProperty={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
              />
            )}
          </Card>
          <div className="card-inner">
            {productProperty && productProperty.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={productProperty?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No product property found</span>
              </div>
            )}
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};
